import { $api } from "../../shared/api"

export const getLoggerById = (device_id: string) => {
    return $api.get("/loggers/" + device_id)
}
export const deleteLoggerById = (device_id: string) => {
    return $api.delete("/logger/" + device_id)
}